import * as React from 'react'
import { memo } from 'react'
const SvgChevronLeft = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    viewBox="0 0 5.717 10"
  >
    <path d="m1.723 4.998 3.784-3.781A.715.715 0 0 0 4.495.206L.208 4.49a.713.713 0 0 0-.021.985l4.3 4.314A.715.715 0 0 0 5.499 8.78Z" />
  </svg>
)
const Memo = memo(SvgChevronLeft)
export default Memo
